import { render, staticRenderFns } from "./ResumoAcordo.vue?vue&type=template&id=7d3748fd"
import script from "./ResumoAcordo.vue?vue&type=script&lang=js"
export * from "./ResumoAcordo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports